export const isDragEvent = (node: HTMLElement | null) => {
	if (!node) return false;
	return !!(
		node.tagName === 'DIV' &&
		(node.firstChild as HTMLElement)?.tagName !== 'IMG'
	);
};

export const isMapPointClick = (node: HTMLElement | null) => {
	if (!node) return false;
	return !!(
		node.tagName === 'IMG' ||
		(node.tagName === 'DIV' &&
			(node.firstChild as HTMLElement)?.tagName === 'IMG')
	);
};

export const isControlButtonClick = (node: HTMLElement | null) => {
	if (!node) return false;
	return node.tagName === 'BUTTON';
};
